/**
 *  RaceSegment
 *
 *  Created by Legman on 21/03/2017.
 *
 */

import Point4 from "./Point4";
import RaceEntity from "./RaceEntity";
import RaceSegmentQuad from "./RaceSegmentQuad";

/**
 * @class
 * @extends RaceEntity
 * @memberOf race
 */
export default class RaceSegment extends RaceEntity {
    /**
     * @param {PIXI.Texture} roadMiddleTexture
     * @param {PIXI.Texture} [roadLeftTexture]
     * @param {PIXI.Texture} [roadRightTexture]
     * @param {PIXI.Texture} [grassLeftTexture]
     * @param {PIXI.Texture} [grassRightTexture]
     */
    constructor(roadMiddleTexture, roadLeftTexture, roadRightTexture, grassLeftTexture, grassRightTexture) {
        // middle road segment
        const view = new PIXI.Sprite(roadMiddleTexture);

        // left grass segment
        view.grassLeft = new PIXI.Sprite(grassLeftTexture);
        view.grassLeft.anchor.x = 1;
        view.addChild(view.grassLeft);

        // right grass segment
        view.grassRight = new PIXI.Sprite(grassRightTexture);
        view.addChild(view.grassRight);

        // left road segment
        view.left = new PIXI.Sprite(roadLeftTexture);
        view.left.y = view.left.height * 0.5;
        view.left.anchor.x = 1.0;
        view.left.anchor.y = 0.5;
        view.addChild(view.left);

        //right road segment
        view.right = new PIXI.Sprite(roadRightTexture);
        view.right.x = view.width;
        view.right.y = view.right.height * 0.5;
        view.right.anchor.y = 0.5;
        view.addChild(view.right);

        super(RaceEntity.TYPE_SEGMENT, view);

        /**
         * @member {RaceSegment}
         */
        this.next = null;

        /**
         * @member {RaceSegment}
         */
        this.previous = null;

        /**
         * @member {number}
         */
        this.width = 0;

        /**
         * @type {RaceSegmentQuad}
         * @private
         */
        this._quad = new RaceSegmentQuad();

        /**
         * @type {Point4}
         * @private
         */
        this._heading = new Point4();
    }

    /**
     * @returns {RaceSegmentQuad}
     */
    getQuad() {
        this._quad.topLeft.x = this.screenPosition.x - this.width;
        this._quad.topLeft.y = this.screenPosition.y;
        this._quad.topRight.x = this.screenPosition.x + this.width;
        this._quad.topRight.y = this.screenPosition.y;
        this._quad.bottomLeft.x = this.previous.screenPosition.x - this.previous.width;
        this._quad.bottomLeft.y = this.previous.screenPosition.y;
        this._quad.bottomRight.x = this.previous.screenPosition.x + this.previous.width;
        this._quad.bottomRight.y = this.previous.screenPosition.y;
        return this._quad;
    }

    /**
     * @returns {Point4}
     */
    getHeading() {
        this._heading.x = this.next.worldPosition.x - this.worldPosition.x;
        this._heading.y = this.next.worldPosition.y - this.worldPosition.y;
        this._heading.z = this.next.worldPosition.z - this.worldPosition.z;
        this._heading.w = 1;

        const length = Math.sqrt(
            this._heading.x * this._heading.x + this._heading.y * this._heading.y + this._heading.z * this._heading.z);

        this._heading.x /= length;
        this._heading.y /= length;
        this._heading.z /= length;
        return this._heading;
    }
}
